import { Toaster as SonnerToaster, toast } from "sonner";
import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react";

export { toast };

export function Toaster({ dir = "ltr" }: { dir?: "ltr" | "rtl" }) {
  return (
    <SonnerToaster
      dir={dir}
      position={dir === "rtl" ? "bottom-left" : "bottom-right"}
      richColors={false}
      closeButton
      icons={{
        success: <CheckCircle2 className="size-4 text-success-600" />,
        error: <XCircle className="size-4 text-danger-600" />,
        warning: <AlertTriangle className="size-4 text-warning-600" />,
        info: <Info className="size-4 text-seablue-600" />,
      }}
      toastOptions={{
        classNames: {
          toast: "!rounded-xl !border !border-sand-200 !bg-white !text-foreground !shadow-sand-lg !font-sans",
          title: "!text-sm !font-semibold",
          description: "!text-xs !text-muted-foreground",
          actionButton: "!bg-aegold-600 !text-white !rounded-lg",
          cancelButton: "!bg-sand-100 !text-foreground !rounded-lg",
        },
      }}
    />
  );
}

export function InlineAlert({ tone = "info", title, children, className }: { tone?: "info" | "success" | "warning" | "danger" | "ai"; title?: React.ReactNode; children?: React.ReactNode; className?: string }) {
  const map = {
    info: { cls: "border-seablue-200 bg-seablue-50 text-seablue-900", Icon: Info },
    success: { cls: "border-success-100 bg-success-50 text-success-700", Icon: CheckCircle2 },
    warning: { cls: "border-warning-100 bg-warning-50 text-warning-700", Icon: AlertTriangle },
    danger: { cls: "border-danger-100 bg-danger-50 text-danger-700", Icon: XCircle },
    ai: { cls: "border-aegold-200 bg-gradient-to-r from-aegold-50 to-seablue-50 text-aeblack-900", Icon: Info },
  }[tone];
  return (
    <div role={tone === "danger" ? "alert" : "status"} data-slot="inline-alert" data-tone={tone} className={`flex items-start gap-3 rounded-xl border p-3 text-sm ${map.cls} ${className ?? ""}`}>
      <map.Icon className="mt-0.5 size-4 shrink-0" />
      <div className="min-w-0 flex-1">
        {title ? <p className="font-semibold">{title}</p> : null}
        {children ? <div className={title ? "mt-0.5 text-[13px]" : ""}>{children}</div> : null}
      </div>
    </div>
  );
}
